module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10068.a075b0a3.jpg";